import React, { useEffect, useState } from 'react';
import './Community.css';

function Community() {
  const [url, setUrl] = useState('https://community.afterschoolhq.com');

  useEffect(() => {
    document.title = 'AfterSchool HQ Community';
    
    // Get URL from localStorage
    const storedUrl = localStorage.getItem('communityIFrameUrl');
    console.log('Community URL from localStorage:', storedUrl);
    if (storedUrl) {
      setUrl(storedUrl);
      // Remove the URL from localStorage after retrieving it
      localStorage.removeItem('communityIFrameUrl');
    }
  }, []);

  return (
    <div className="community-container">
      <iframe
        src={url}
        title="Community"
        className="full-screen-iframe"
        allow="camera *; microphone *"
      />
    </div>
  );
}

export default Community; 